import { useEffect, useState } from 'react';
import { SidebarTabLayout } from '../shared/SidebarTabLayout';
import { useDispatch, useSelector } from 'react-redux';
import { callModel } from '../../../../../features/call';
import { CallsHeader } from './CallsHeader';
import { Loader } from '../../../../../shared/ui';
import { CallItem } from './CallItem';
import { CallPreview } from './CallPreview';
import { MakePublicModal } from './MakePublicModal';
import { NoCallsFoundScreen } from './NoCallsFoundScreen';
import { InsertVariant } from './lib/config';

export const CallsTab = () => {
  const dispatch = useDispatch();
  const isCallListLoading = useSelector(
    callModel.selectors.selectIsCallListLoading
  );

  const currentCall = useSelector(callModel.selectors.selectCurrentCall);

  const callList = useSelector(callModel.selectors.selectCalls);

  const [insertVariant, setInsertVariant] = useState<InsertVariant | null>(
    null
  );

  const [makePublicConfirmationCallId, setMakePublicConfirmationCallId] =
    useState<string | null>(null);

  useEffect(() => {
    return () => {
      dispatch(callModel.actions.setCurrentCall(undefined));
    };
  }, [dispatch]);

  return (
    <div className="w-153">
      <MakePublicModal
        isOpen={Boolean(makePublicConfirmationCallId)}
        onClose={() => {
          setMakePublicConfirmationCallId(null);
          setInsertVariant(null);
        }}
        callId={makePublicConfirmationCallId || ''}
        insertVariant={insertVariant}
      />
      {currentCall ? (
        <CallPreview
          setInsertVariant={setInsertVariant}
          setMakePublicConfirmationCallId={setMakePublicConfirmationCallId}
        />
      ) : (
        <SidebarTabLayout headerComponent={<CallsHeader />}>
          {isCallListLoading ? (
            <div className="flex-1">
              <Loader />
            </div>
          ) : callList.length > 0 ? (
            <section className="grid flex-grow grid-cols-2 gap-3 overflow-x-hidden overflow-y-auto place-content-start">
              {callList.map((call) => (
                <CallItem
                  key={call.id}
                  item={call}
                  setMakePublicConfirmationCallId={
                    setMakePublicConfirmationCallId
                  }
                  setInsertVariant={setInsertVariant}
                />
              ))}
            </section>
          ) : (
            <NoCallsFoundScreen />
          )}
        </SidebarTabLayout>
      )}
    </div>
  );
};
